var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { evenCharacters, oddCharacters, remainder } from './constants/it/checkSumLetterCharacters';
import { IncorrectLengthError, InvalidControlKeyError } from './errors';
import countryAgnosticValidateSsn from './validateSsn';
/**
 *
 * 3 letter = the first three consonants of firstname
 * 3 letter = the first three consonants of lastname
 *
 * 2 number = Year of birth (two digits)
 * 1 letter = Month of birth (one letter) A = January etc...
 * 2 number = Birthday and gender (2 digits) if the person is a woman, 40 is added
 *
 * 4 alphanumeric = Town of birth code (4 alphanumeric)
 * 1 letter = Check character
 *
 * https://en.wikipedia.org/wiki/Italian_fiscal_code
 * https://www.nonsolocap.it/codice-fiscale/?cg=JEREMY&nm=PIEDNOEL&ss=M&lg=MILANO+%28MI%29&dn=04/10/1997
 */
var formatOfficial = '([A-Z]{6}[0-9]{2}[A-Z]{1}[0-9]{2}[A-Z0-9]{5})';
var formatNumber = '([0-9]{2,11})';
var ssnRegexGenerator = function (strict) {
    if (strict === void 0) { strict = true; }
    var format = "".concat(formatOfficial, "|").concat(formatNumber);
    return strict ? new RegExp("^".concat(format, "$")) : new RegExp(format);
};
export var ssnRegex = ssnRegexGenerator();
export var ssnRegexExtract = ssnRegexGenerator(false);
export var validateSsn = function (ssn) {
    return countryAgnosticValidateSsn({
        ssnRegex: ssnRegexGenerator(),
        computeSsnControlKey: computeSsnControlKey,
        extractSsnControlKey: extractSsnControlKey,
    }, ssn);
};
var isNumber = function (val) { return /^\d+$/.test(val); };
var validateNumberSSN = function (ssn) {
    if (ssn.length < 2 || ssn.length > 11) {
        throw new IncorrectLengthError(15, ssn.length);
    }
};
export function computeSsnControlKey(ssnWithOrWithoutCheckSumLetter) {
    if (isNumber(ssnWithOrWithoutCheckSumLetter)) {
        validateNumberSSN(ssnWithOrWithoutCheckSumLetter);
        return ssnWithOrWithoutCheckSumLetter;
    }
    var ssnWithoutKey = ssnWithOrWithoutCheckSumLetter.slice(0, 15);
    if (ssnWithoutKey.length !== 15) {
        throw new IncorrectLengthError(15, ssnWithoutKey.length);
    }
    var oneBasedIndexIsEven = function (_, i) { return (i + 1) % 2 === 0; };
    var oneBasedIndexIsOdd = function (_, i) { return !oneBasedIndexIsEven(_, i); };
    var ssnCharacters = ssnWithoutKey.split('');
    var evenIndexedChars = ssnCharacters.filter(oneBasedIndexIsEven);
    var oddIndexedChars = ssnCharacters.filter(oneBasedIndexIsOdd);
    var evenValues = transformCharsOnCheckValues(evenIndexedChars, evenCharacters);
    var oddValues = transformCharsOnCheckValues(oddIndexedChars, oddCharacters);
    return computeRemainder(__spreadArray(__spreadArray([], evenValues, true), oddValues, true));
}
export function extractSsnControlKey(ssnWithKey) {
    if (isNumber(ssnWithKey)) {
        validateNumberSSN(ssnWithKey);
        return ssnWithKey;
    }
    if (ssnWithKey.length !== 16) {
        throw new IncorrectLengthError(16, ssnWithKey.length);
    }
    var controlKey = ssnWithKey.charAt(15);
    var REGEX_A_TO_Z = new RegExp('^[A-Z]{1}$');
    if (!REGEX_A_TO_Z.test(controlKey)) {
        throw new InvalidControlKeyError(controlKey, ssnWithKey);
    }
    return controlKey;
}
function transformCharsOnCheckValues(chars, values) {
    return chars.map(function (c) { return values[c]; });
}
function computeRemainder(values) {
    var remainderValue = values.reduce(sum) % 26;
    return remainder[remainderValue];
}
function sum(accumulator, currentValue) {
    return accumulator + currentValue;
}
